import { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Modal } from 'apps/studio/components/modals'
import { UpgradeIcon } from '@gocanvas/gcds/icons'
import { appSettingsActions } from 'apps/formsCreationKit/store/reducers/settings/appSettings'
import { entitiesSelector } from 'apps/formsCreationKit/store/selectors/entities'
import { assembleForm } from 'apps/builder/lib/transforms'
import { stagePlgForm } from 'apps/studio/lib/builderRequests'
import PurchaseModalHero from 'apps/studio/assets/purchase-modal-hero.svg'

const { toggleModal } = appSettingsActions

const STEPS = [
  'Create your account',
  'Verify your email',
  'Login to GoCanvas – and your form goes live',
]

export const PurchaseModal = () => {
  const dispatch = useDispatch()
  const modalRef = useRef()
  const entities = useSelector(entitiesSelector)

  const closeDialog = () => {
    dispatch(toggleModal({ activeModal: '' }))
  }

  const handlePurchase = async () => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({ event: 'plg_purchase_started' })
    try {
      const { pdf, pages, layouts, elements, ...formEntities } = entities
      const formData = assembleForm(formEntities)
      // UI-only fields that aren't Form columns; Form.from_hash rejects them at signup
      delete formData.form?.defaultAppName
      delete formData.form?.placeholder
      formData.pdf_layout = { pdf, pages, layouts, elements }
      await stagePlgForm(formData)
    } catch (err) {
      console.error('PLG form staging failed', err)
    } finally {
      window.location.href = '/signup/plg'
    }
  }

  useEffect(() => {
    const dialog = modalRef.current
    if (!dialog) return
    const handleBackdropClick = event => {
      if (event.target === dialog) closeDialog()
    }
    dialog.addEventListener('click', handleBackdropClick)
    return () => dialog.removeEventListener('click', handleBackdropClick)
  }, [])

  return (
    <Modal className="gcds--modal purchase--modal" ref={modalRef}>
      <div className="modal--content purchase-modal--content">
        <div className="purchase-modal--columns">
          <div className="purchase-modal--left">
            <h2 className="purchase-modal--title">
              Your form is ready. Get your crew on it.
            </h2>
            <p className="purchase-modal--body">
              Start your free trial to publish, share with your team, and start
              collecting field data today. Only $9 per user per month after your
              trial, billed annually.
            </p>
            <PurchaseModalHero
              className="purchase-modal--hero"
              aria-hidden="true"
            />
          </div>
          <div className="purchase-modal--right">
            <div className="purchase-modal--header">
              <UpgradeIcon
                className="purchase-modal--crown"
                aria-hidden="true"
              />
              <div className="purchase-modal--unlock-title">How to get started:</div>
            </div>
            <div className="purchase-modal--steps">
              <ol className="purchase-modal--step-list">
                {STEPS.map(step => (
                  <li key={step}>{step}</li>
                ))}
              </ol>
            </div>
            <button
              className="gcds--button button--primary purchase-modal--buy-button"
              type="button"
              onClick={handlePurchase}
            >
              Start My Free Trial
            </button>
          </div>
        </div>
      </div>
    </Modal>
  )
}
